export default "__VITE_PUBLIC_ASSET__a5fb1360__"